export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10459.38bee6c6.jpg";